module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate2.e9d3079.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate2.png
// module id = 755
// module chunks = 0